import { register } from 'register-service-worker';

/* eslint-disable no-console */

if (
    process.env.NODE_ENV === 'production' &&
    !window.location.search.includes('no-sw')
) {
    console.log('You are in production mode');
    // eslint-disable-next-line no-unused-vars
    let serviceWorkRegistration;

    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
            );
        },
        registered(registration) {
            console.log('Service worker has been registered.');
            serviceWorkRegistration = registration;
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound() {
            console.log('New content is downloading.');
        },
        updated(registration) {
            console.log('New content is available; refreshing.');

            if (registration && registration.waiting) {
                // 先附加監聽器，再發送 SKIP_WAITING，避免 race condition
                registration.waiting.addEventListener('statechange', event => {
                    if (event.target.state === 'activated') {
                        window.location.reload(true);
                    }
                });

                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
        },
        offline() {
            console.log(
                'No internet connection found. App is running in offline mode.'
            );
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
        unsupported() {
            console.log('Service worker is not supported by the browser.');
        },
    });
}
